// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FiltersDataSource.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import { FIELDS, DATA_SOURCE } from 'logic/data/Izenda.ReportDesignerConstants';
import { observer } from 'mobx-react';
import Panel from 'share/components/controls/Izenda.Panel';
import FiltersBody from 'modules/ReportDesigner/Fields/Filter/Izenda.FilterBody';
import {get} from 'lodash/fp';
const FILTERS_HEADER_LABEL = FIELDS.FILTERS_HEADER_LABEL;
const FITLERS_PANEL_UI = DATA_SOURCE.FITLERS_PANEL_UI;

const FilterHeaderPanel = observer(({ collapseToggle, updateResults, localization }) => {
  return (
    <div className='izenda-FilterDatasource__Header'>
      <div className='inline-table header-label' onClick={collapseToggle}>
        <i className='icon-toggle-thick' />
        <strong>{FILTERS_HEADER_LABEL}</strong>
      </div>
      <div className='updateResults-btn'>
        <button onClick={updateResults} className='btn btn-primary'>
          {localization && localization.getText('REPORTDESIGNER_LABEL_APPLY_FILTER')}
        </button>
      </div>
    </div>
  );
});

FilterHeaderPanel.displayName = 'FilterHeaderPanel';

@observer
export default class FiltersDataSource extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired
  };

  dropMessage(message: string) {
    return this.props.confirmFn('Information', {
      description: message,
      type: 'info',
      showCloseIndicator: true
    });
  }

  render() {
    const { fieldStore, viewMode, updateResultsInfo} = this.props;
    const paramFilterFields = fieldStore.reportFilters.paramFilterFields || [];
    const headerComponent = {
      component: FilterHeaderPanel,
      updateResults: get('updateResults', updateResultsInfo),
      localization: get('localization', this.props)
    };

    return (
      <Panel
        className='full-height'
        header={headerComponent}
        collapsible
        initState
        resizable
        defaultValue={FITLERS_PANEL_UI.minHeight}
        minValue={FITLERS_PANEL_UI.minHeight}
        maxValue={FITLERS_PANEL_UI.maxHeight}
        toViewPortDimension
      >
        <FiltersBody
          store={fieldStore}
          filterFields={paramFilterFields}
          dropMessage={this.dropMessage}
          viewMode={viewMode}
          showPosition={false}
        />
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSource/Izenda.FiltersDataSource.js